/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import { isNullOrUndefined, extend } from '@syncfusion/ej2-base';
import { getRecurrenceStringFromDate, generate } from '../../recurrence-editor/date-generator';
import * as events from '../base/constant';
import * as util from '../base/util';
/**
 * Schedule CRUD operations
 */
var Crud = /** @class */ (function () {
    function Crud(parent) {
        this.parent = parent;
        this.crudObj = { sourceEvent: null, targetEvent: null, isCrudAction: false };
    }
    Crud.prototype.getQuery = function () {
        var start = this.parent.activeView.startDate();
        var end = this.parent.activeView.endDate();
        return this.parent.dataModule.generateQuery(start, end);
    };
    Crud.prototype.getTable = function () {
        if (this.parent.eventSettings.query) {
            var query = this.parent.eventSettings.query.clone();
            return query.fromTable;
        }
        return null;
    };
    Crud.prototype.refreshData = function (args) {
        var _this = this;
        var actionArgs = {
            requestType: args.requestType, cancel: false, data: args.data,
            addedRecords: args.editParams.addedRecords, changedRecords: args.editParams.changedRecords,
            deletedRecords: args.editParams.deletedRecords
        };
        if (this.parent.dragAndDropModule && this.parent.dragAndDropModule.actionObj && this.parent.dragAndDropModule.actionObj.element) {
            this.parent.dragAndDropModule.actionObj.element.style.display = 'none';
        }
        if (this.parent.resizeModule && this.parent.resizeModule.actionObj && this.parent.resizeModule.actionObj.element) {
            this.parent.resizeModule.actionObj.element.style.display = 'none';
        }
        if (this.parent.activeViewOptions.group.resources.length > 0 && !this.parent.activeViewOptions.group.allowGroupEdit
            && !this.parent.rowAutoHeight && !this.parent.virtualScrollModule && this.parent.activeViewOptions.group.byGroupID) {
            if (args.requestType === 'eventCreated' || args.requestType === 'eventRemoved') {
                this.crudObj.isCrudAction = true;
                this.crudObj.sourceEvent = [];
                var crudData = args.data instanceof Array ? (args.data.length === 0 &&
                    args.requestType === 'eventRemoved' ? args.editParams.deletedRecords : args.data) :
                    ((typeof args.data === 'string' || typeof args.data === 'number') && args.requestType === 'eventRemoved') ?
                        args.editParams.deletedRecords : [args.data];
                var _loop_1 = function (data) {
                    this_1.crudObj.isCrudAction = !(args.requestType === 'eventRemoved' && !isNullOrUndefined(data.parent));
                    var groupIndex = this_1.parent.eventBase.getGroupIndexFromEvent(data);
                    if (groupIndex > -1 && this_1.parent.crudModule.crudObj.sourceEvent.filter(function (tdData) { return tdData.groupIndex === groupIndex; }).length === 0
                        && this_1.crudObj.isCrudAction) {
                        this_1.crudObj.sourceEvent.push(this_1.parent.resourceBase.lastResourceLevel[groupIndex]);
                    }
                };
                var this_1 = this;
                for (var _i = 0, crudData_1 = crudData; _i < crudData_1.length; _i++) {
                    var data = crudData_1[_i];
                    _loop_1(data);
                }
                this.crudObj.targetEvent = this.crudObj.sourceEvent;
            }
        }
        if (this.parent.dataModule.dataManager.dataSource.offline) {
            this.parent.trigger(events.actionComplete, actionArgs, function (offlineArgs) {
                if (!offlineArgs.cancel) {
                    _this.parent.renderModule.refreshDataManager();
                }
            });
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            args.promise.then(function (e) {
                if (!_this.parent || _this.parent && _this.parent.isDestroyed) {
                    return;
                }
                _this.parent.trigger(events.actionComplete, actionArgs, function (onlineArgs) {
                    if (!onlineArgs.cancel) {
                        _this.parent.renderModule.refreshDataManager();
                    }
                });
            }).catch(function (e) {
                if (!_this.parent || _this.parent && _this.parent.isDestroyed) {
                    return;
                }
                _this.parent.trigger(events.actionFailure, { error: e });
            });
        }
    };
    Crud.prototype.addEvent = function (eventData) {
        var _this = this;
        if (this.parent.eventSettings.allowAdding) {
            if (!this.isBlockEvent(eventData) && this.parent.eventBase.isBlockRange(eventData)) {
                this.parent.quickPopup.openValidationError('blockAlert', eventData);
                return;
            }
            var addEvents = (eventData instanceof Array) ? eventData : [eventData];
            var args = {
                requestType: 'eventCreate', cancel: false, data: addEvents,
                addedRecords: addEvents, changedRecords: [], deletedRecords: []
            };
            this.parent.trigger(events.actionBegin, args, function (addArgs) {
                if (!addArgs.cancel) {
                    var fields = _this.parent.eventFields;
                    var editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                    var promise = void 0;
                    if (addArgs.addedRecords instanceof Array) {
                        for (var _i = 0, _a = addArgs.addedRecords; _i < _a.length; _i++) {
                            var event_1 = _a[_i];
                            var eventData_1 = extend({}, _this.parent.eventBase.processTimezone(event_1, true), null, true);
                            editParams.addedRecords.push(eventData_1);
                        }
                        promise = _this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, _this.getTable(), _this.getQuery());
                    }
                    else {
                        var event_2 = _this.parent.eventBase.processTimezone(addArgs.addedRecords, true);
                        editParams.addedRecords.push(event_2);
                        promise = _this.parent.dataModule.dataManager.insert(event_2, _this.getTable(), _this.getQuery());
                    }
                    var crudArgs = {
                        requestType: 'eventCreated', cancel: false, data: addArgs.addedRecords, promise: promise, editParams: editParams
                    };
                    _this.refreshData(crudArgs);
                }
            });
        }
    };
    Crud.prototype.saveEvent = function (eventData, action) {
        var _this = this;
        if (this.parent.eventSettings.allowEditing) {
            if (this.parent.currentAction !== 'EditFollowingEvents' && !this.isBlockEvent(eventData)
                && this.parent.eventBase.isBlockRange(eventData)) {
                this.parent.quickPopup.openValidationError('blockAlert', eventData);
                return;
            }
            this.parent.currentAction = action;
            if (action) {
                switch (action) {
                    case 'Save':
                        this.processSave(eventData);
                        break;
                    case 'EditOccurrence':
                        this.processOccurrences(eventData, action);
                        break;
                    case 'EditFollowingEvents':
                        this.processFollowSeries(eventData, action);
                        break;
                    case 'EditSeries':
                        this.processEntireSeries(eventData, action);
                        break;
                }
            }
            else {
                var updateEvents = (eventData instanceof Array) ? eventData : [eventData];
                var args = {
                    requestType: 'eventChange', cancel: false, data: eventData,
                    addedRecords: [], changedRecords: updateEvents, deletedRecords: []
                };
                this.parent.trigger(events.actionBegin, args, function (saveArgs) {
                    if (!saveArgs.cancel) {
                        var promise = void 0;
                        var fields = _this.parent.eventFields;
                        var editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                        if (saveArgs.changedRecords instanceof Array) {
                            for (var _i = 0, _a = saveArgs.changedRecords; _i < _a.length; _i++) {
                                var event_3 = _a[_i];
                                var eventData_2 = extend({}, _this.parent.eventBase.processTimezone(event_3, true), null, true);
                                editParams.changedRecords.push(eventData_2);
                            }
                            promise = _this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, _this.getTable(), _this.getQuery());
                        }
                        else {
                            var event_4 = _this.parent.eventBase.processTimezone(saveArgs.changedRecords, true);
                            editParams.changedRecords.push(event_4);
                            promise = _this.parent.dataModule.dataManager.update(fields.id, event_4, _this.getTable(), _this.getQuery());
                        }
                        var crudArgs = {
                            requestType: 'eventChanged', cancel: false,
                            data: saveArgs.changedRecords, promise: promise, editParams: editParams
                        };
                        _this.refreshData(crudArgs);
                    }
                });
            }
        }
    };
    Crud.prototype.deleteEvent = function (eventData, action) {
        var _this = this;
        if (this.parent.eventSettings.allowDeleting) {
            this.parent.currentAction = action;
            var deleteEvents = [];
            if (typeof eventData === 'string' || typeof eventData === 'number') {
                deleteEvents = this.parent.eventsData.filter(function (eventObj) {
                    return eventObj[_this.parent.eventFields.id] === eventData;
                });
            }
            else {
                deleteEvents = (eventData instanceof Array ? eventData : [eventData]);
            }
            if (action) {
                switch (action) {
                    case 'Delete':
                        this.processDelete(deleteEvents);
                        break;
                    case 'DeleteOccurrence':
                        this.processOccurrences(deleteEvents, action);
                        break;
                    case 'DeleteFollowingEvents':
                        this.processFollowSeries(deleteEvents, action);
                        break;
                    case 'DeleteSeries':
                        this.processEntireSeries(deleteEvents, action);
                        break;
                }
            }
            else {
                var args = {
                    requestType: 'eventRemove', cancel: false, data: eventData,
                    addedRecords: [], changedRecords: [], deletedRecords: deleteEvents
                };
                this.parent.trigger(events.actionBegin, args, function (deleteArgs) {
                    if (!deleteArgs.cancel) {
                        var promise = void 0;
                        var fields = _this.parent.eventFields;
                        var editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                        if (deleteArgs.deletedRecords.length > 1) {
                            editParams.deletedRecords = editParams.deletedRecords.concat(deleteArgs.deletedRecords);
                            promise = _this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, _this.getTable(), _this.getQuery());
                        }
                        else {
                            editParams.deletedRecords.push(deleteArgs.deletedRecords[0]);
                            promise = _this.parent.dataModule.dataManager.remove(fields.id, deleteArgs.deletedRecords[0], _this.getTable(), _this.getQuery());
                        }
                        _this.parent.eventBase.selectWorkCellByTime(deleteArgs.deletedRecords);
                        var crudArgs = {
                            requestType: 'eventRemoved', cancel: false,
                            data: deleteArgs.deletedRecords, promise: promise, editParams: editParams
                        };
                        _this.refreshData(crudArgs);
                    }
                });
            }
        }
    };
    Crud.prototype.processOccurrences = function (eventData, action) {
        var _this = this;
        var occurrenceData = [];
        var isDeletedRecords = false;
        if (eventData instanceof Array) {
            for (var _i = 0, eventData_3 = eventData; _i < eventData_3.length; _i++) {
                var event_5 = eventData_3[_i];
                occurrenceData.push({ occurrence: event_5, parent: this.getParentEvent(event_5) });
            }
        }
        else {
            occurrenceData = { occurrence: eventData, parent: this.getParentEvent(eventData) };
        }
        var updateEvents = (eventData instanceof Array) ? eventData : [eventData];
        var args = {
            requestType: action === 'EditOccurrence' ? 'eventChange' : 'eventRemove', cancel: false,
            addedRecords: [], changedRecords: updateEvents, deletedRecords: []
        };
        args.data = occurrenceData;
        this.parent.trigger(events.actionBegin, args, function (occurrenceArgs) {
            if (!occurrenceArgs.cancel) {
                var fields = _this.parent.eventFields;
                var editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                var occurrenceEvents = (occurrenceData instanceof Array ? occurrenceData : [occurrenceData]);
                var _loop_2 = function (a, count) {
                    var childEvent = occurrenceArgs.changedRecords[a];
                    var parentEvent = occurrenceEvents[a].parent;
                    var parentException = parentEvent[fields.recurrenceException];
                    var editedData = void 0;
                    var exceptionDate = void 0;
                    switch (action) {
                        case 'EditOccurrence':
                            editedData = _this.parent.eventsProcessed.filter(function (event) { return event.Guid === childEvent.Guid; })[0];
                            exceptionDate = _this.excludeDateCheck(editedData[fields.startTime], parentException);
                            if (exceptionDate !== parentEvent[fields.recurrenceException]) {
                                parentEvent[fields.recurrenceException] = exceptionDate;
                                childEvent[fields.recurrenceException] = getRecurrenceStringFromDate(editedData[fields.startTime]);
                                childEvent[fields.recurrenceID] = parentEvent[fields.id];
                                childEvent[fields.followingID] = null;
                                editParams.changedRecords.push(_this.parent.eventBase.processTimezone(parentEvent, true));
                                editParams.addedRecords.push(_this.parent.eventBase.processTimezone(childEvent, true));
                            }
                            else {
                                editParams.changedRecords.push(_this.parent.eventBase.processTimezone(childEvent, true));
                            }
                            break;
                        case 'DeleteOccurrence':
                            if (!childEvent[fields.recurrenceException]) {
                                parentEvent[fields.recurrenceException] =
                                    _this.excludeDateCheck(childEvent[fields.startTime], parentException);
                                editParams.changedRecords.push(_this.parent.eventBase.processTimezone(parentEvent, true));
                            }
                            if (childEvent[fields.id] !== parentEvent[fields.id]) {
                                editParams.deletedRecords.push(childEvent);
                                isDeletedRecords = true;
                            }
                            break;
                    }
                };
                for (var a = 0, count = occurrenceArgs.changedRecords.length; a < count; a++) {
                    _loop_2(a, count);
                }
                var promise = _this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, _this.getTable(), _this.getQuery());
                _this.parent.eventBase.selectWorkCellByTime(occurrenceArgs.changedRecords);
                var crudArgs = {
                    requestType: action === 'EditOccurrence' ? 'eventChanged' : 'eventRemoved',
                    cancel: false, data: isDeletedRecords ? occurrenceArgs.deletedRecords : occurrenceArgs.changedRecords,
                    promise: promise, editParams: editParams
                };
                _this.refreshData(crudArgs);
            }
        });
    };
    Crud.prototype.processFollowSeries = function (eventData, action) {
        var _this = this;
        var followData = [];
        if (eventData instanceof Array) {
            for (var _i = 0, eventData_4 = eventData; _i < eventData_4.length; _i++) {
                var event_6 = eventData_4[_i];
                followData.push({ occurrence: event_6, parent: this.getParentEvent(event_6) });
            }
        }
        else {
            followData = { occurrence: eventData, parent: this.getParentEvent(eventData) };
        }
        var updateFollowEvents = (eventData instanceof Array) ? eventData : [eventData];
        var args = {
            requestType: action === 'EditFollowingEvents' ? 'eventChange' : 'eventRemove', cancel: false,
            addedRecords: [], changedRecords: updateFollowEvents, deletedRecords: []
        };
        args.data = followData;
        this.parent.trigger(events.actionBegin, args, function (followArgs) {
            if (!followArgs.cancel) {
                var fields_1 = _this.parent.eventFields;
                var editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                var followEvents = followData instanceof Array ? followData : [followData];
                var _loop_3 = function (a, count) {
                    var childEvent = followArgs.changedRecords[a];
                    var parentEvent = followEvents[a].parent;
                    var followData_1 = _this.parent.eventBase.getEventCollections(parentEvent, childEvent);
                    var isSpanned = void 0;
                    switch (action) {
                        case 'EditFollowingEvents':
                            _this.processRecurrenceRule(parentEvent, childEvent);
                            isSpanned = !_this.parent.eventBase.isFollowingEvent(parentEvent, childEvent);
                            childEvent[fields_1.followingID] = isSpanned ? null : parentEvent[fields_1.id];
                            childEvent[fields_1.recurrenceID] = null;
                            editParams.addedRecords.push(_this.parent.eventBase.processTimezone(childEvent, true));
                            editParams.changedRecords.push(_this.parent.eventBase.processTimezone(parentEvent, true));
                            if (!_this.parent.uiStateValues.isIgnoreOccurrence) {
                                childEvent[fields_1.recurrenceException] = null;
                                if (followData_1.occurrence.length > 0) {
                                    var rule = followData_1.occurrence.slice(-1)[0][fields_1.recurrenceRule];
                                    if (rule.indexOf('COUNT') === -1) {
                                        childEvent[fields_1.recurrenceRule] = rule;
                                    }
                                }
                                if (followData_1.follow.length > 0) {
                                    childEvent[fields_1.recurrenceRule] = followData_1.follow.slice(-1)[0][fields_1.recurrenceRule];
                                    editParams.deletedRecords = editParams.deletedRecords.concat(followData_1.follow);
                                }
                                if (isSpanned) {
                                    followData_1.occurrence = followData_1.occurrence.filter(function (eventObj) {
                                        return eventObj[fields_1.recurrenceID] === childEvent[fields_1.id];
                                    });
                                }
                                editParams.deletedRecords = editParams.deletedRecords.concat(followData_1.occurrence);
                            }
                            break;
                        case 'DeleteFollowingEvents':
                            _this.processRecurrenceRule(parentEvent, childEvent[fields_1.startTime]);
                            editParams.changedRecords.push(_this.parent.eventBase.processTimezone(parentEvent, true));
                            editParams.deletedRecords = editParams.deletedRecords.concat(followData_1.occurrence).concat(followData_1.follow);
                            break;
                    }
                };
                for (var a = 0, count = followArgs.changedRecords.length; a < count; a++) {
                    _loop_3(a, count);
                }
                var promise = _this.parent.dataModule.dataManager.saveChanges(editParams, fields_1.id, _this.getTable(), _this.getQuery());
                _this.parent.eventBase.selectWorkCellByTime(followArgs.changedRecords);
                var crudArgs = {
                    requestType: action === 'EditFollowingEvents' ? 'eventChanged' : 'eventRemoved',
                    cancel: false, data: followArgs.changedRecords, promise: promise, editParams: editParams
                };
                _this.refreshData(crudArgs);
            }
        });
    };
    Crud.prototype.processEntireSeries = function (eventData, action) {
        var _this = this;
        var seriesData = [];
        var isDeletedRecords = false;
        if (eventData instanceof Array) {
            for (var _i = 0, eventData_5 = eventData; _i < eventData_5.length; _i++) {
                var event_7 = eventData_5[_i];
                seriesData.push(this.getParentEvent(event_7, true));
            }
        }
        else {
            seriesData = this.getParentEvent(eventData, true);
        }
        var updateSeriesEvents = (eventData instanceof Array) ? eventData : [eventData];
        var args = {
            requestType: action === 'EditSeries' ? 'eventChange' : 'eventRemove', cancel: false,
            addedRecords: [], changedRecords: updateSeriesEvents, deletedRecords: []
        };
        args.data = seriesData;
        this.parent.trigger(events.actionBegin, args, function (seriesArgs) {
            if (!seriesArgs.cancel) {
                var fields_2 = _this.parent.eventFields;
                var editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                var seriesEvents = seriesData instanceof Array ? seriesData : [seriesData];
                var _loop_4 = function (a, count) {
                    var childEvent = seriesArgs.changedRecords[a];
                    var parentEvent = seriesEvents[a];
                    var eventCollections = _this.parent.eventBase.getEventCollections(parentEvent);
                    var deletedEvents = eventCollections.follow.concat(eventCollections.occurrence);
                    switch (action) {
                        case 'EditSeries':
                            if ((childEvent[fields_2.startTime] > parentEvent[fields_2.startTime]) && childEvent[fields_2.recurrenceRule]) {
                                _this.processRecurrenceRule(parentEvent, childEvent);
                            }
                            childEvent[fields_2.id] = parentEvent[fields_2.id];
                            childEvent[fields_2.recurrenceID] = null;
                            childEvent[fields_2.followingID] = null;
                            if (_this.parent.uiStateValues.isIgnoreOccurrence && childEvent[fields_2.recurrenceException]) {
                                var originalParent = _this.parent.eventsData.filter(function (eventObj) {
                                    return eventObj[fields_2.id] === childEvent[fields_2.id];
                                });
                                if (originalParent.length > 0) {
                                    childEvent[fields_2.recurrenceRule] = originalParent[0][fields_2.recurrenceRule];
                                }
                            }
                            else {
                                childEvent[fields_2.recurrenceException] = null;
                                editParams.deletedRecords = editParams.deletedRecords.concat(deletedEvents);
                            }
                            editParams.changedRecords.push(_this.parent.eventBase.processTimezone(childEvent, true));
                            _this.parent.uiStateValues.isIgnoreOccurrence = false;
                            break;
                        case 'DeleteSeries':
                            editParams.deletedRecords = editParams.deletedRecords.concat(deletedEvents.concat(parentEvent));
                            isDeletedRecords = true;
                            break;
                    }
                };
                for (var a = 0, count = seriesArgs.changedRecords.length; a < count; a++) {
                    _loop_4(a, count);
                }
                var promise = _this.parent.dataModule.dataManager.saveChanges(editParams, fields_2.id, _this.getTable(), _this.getQuery());
                _this.parent.eventBase.selectWorkCellByTime(seriesArgs.changedRecords);
                var crudArgs = {
                    requestType: action === 'EditSeries' ? 'eventChanged' : 'eventRemoved',
                    cancel: false, data: isDeletedRecords ? seriesArgs.deletedRecords : seriesArgs.changedRecords,
                    promise: promise, editParams: editParams
                };
                _this.refreshData(crudArgs);
            }
        });
    };
    Crud.prototype.processDelete = function (eventData) {
        var _this = this;
        var deleteData = [];
        for (var _i = 0, eventData_6 = eventData; _i < eventData_6.length; _i++) {
            var eventObj = eventData_6[_i];
            if (eventObj[this.parent.eventFields.recurrenceRule]) {
                deleteData.push({ occurrence: eventObj, parent: this.getParentEvent(eventObj) });
            }
            else {
                deleteData.push(eventObj);
            }
        }
        var args = {
            requestType: 'eventRemove', cancel: false,
            addedRecords: [], changedRecords: [], deletedRecords: eventData
        };
        args.data = deleteData;
        this.parent.trigger(events.actionBegin, args, function (deleteArgs) {
            if (!deleteArgs.cancel) {
                var fields_3 = _this.parent.eventFields;
                var editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                var _loop_5 = function (a, count) {
                    var isDelete = isNullOrUndefined(deleteArgs.deletedRecords[a][_this.parent.eventFields.recurrenceRule]);
                    if (!isDelete) {
                        var parentEvent_1 = deleteData[a].parent;
                        var isEdited = editParams.changedRecords.filter(function (obj) {
                            return obj[fields_3.id] === parentEvent_1[fields_3.id];
                        });
                        var editedDate = deleteArgs.deletedRecords[a][fields_3.startTime];
                        if (isEdited.length > 0) {
                            var editedData = isEdited[0];
                            editedData[fields_3.recurrenceException] =
                                _this.excludeDateCheck(editedDate, editedData[fields_3.recurrenceException]);
                        }
                        else {
                            parentEvent_1[fields_3.recurrenceException] =
                                _this.excludeDateCheck(editedDate, parentEvent_1[fields_3.recurrenceException]);
                        }
                        if (isEdited.length === 0) {
                            editParams.changedRecords.push(_this.parent.eventBase.processTimezone(parentEvent_1, true));
                        }
                        isDelete = deleteArgs.deletedRecords[a][fields_3.id] !== parentEvent_1[fields_3.id];
                    }
                    if (isDelete) {
                        editParams.deletedRecords.push(deleteArgs.deletedRecords[a]);
                    }
                };
                for (var a = 0, count = deleteArgs.deletedRecords.length; a < count; a++) {
                    _loop_5(a, count);
                }
                var promise = _this.parent.dataModule.dataManager.saveChanges(editParams, fields_3.id, _this.getTable(), _this.getQuery());
                var crudArgs = {
                    requestType: 'eventRemoved', cancel: false, data: deleteArgs.deletedRecords, promise: promise, editParams: editParams
                };
                _this.refreshData(crudArgs);
            }
        });
    };
    Crud.prototype.processSave = function (data) {
        var _this = this;
        var eventData = (data instanceof Array) ? data : [data];
        var editData = [];
        for (var _i = 0, eventData_7 = eventData; _i < eventData_7.length; _i++) {
            var eventObj = eventData_7[_i];
            if (eventObj[this.parent.eventFields.recurrenceRule]) {
                editData.push({ occurrence: eventObj, parent: this.getParentEvent(eventObj) });
            }
            else {
                editData.push(eventObj);
            }
        }
        var args = { requestType: 'eventChange', cancel: false, addedRecords: [], changedRecords: eventData, deletedRecords: [] };
        args.data = editData;
        this.parent.trigger(events.actionBegin, args, function (editArgs) {
            if (!editArgs.cancel) {
                var fields = _this.parent.eventFields;
                var editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                for (var _i = 0, _a = editArgs.changedRecords; _i < _a.length; _i++) {
                    var record = _a[_i];
                    if (!isNullOrUndefined(record[fields.recurrenceRule]) && isNullOrUndefined(record[fields.recurrenceException])) {
                        var exceptionString = getRecurrenceStringFromDate(record[fields.startTime]);
                        var parentEle = _this.getParentEvent(record);
                        parentEle[fields.recurrenceException] = isNullOrUndefined(parentEle[fields.recurrenceException]) ?
                            exceptionString : parentEle[fields.recurrenceException].concat(',' + exceptionString);
                        record[fields.id] = _this.parent.getEventMaxID();
                        record[fields.recurrenceException] = exceptionString;
                        editParams.addedRecords.push(_this.parent.eventBase.processTimezone(record, true));
                        editParams.changedRecords.push(_this.parent.eventBase.processTimezone(parentEle, true));
                    }
                    else {
                        editParams.changedRecords.push(_this.parent.eventBase.processTimezone(record, true));
                    }
                }
                var promise = _this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, _this.getTable(), _this.getQuery());
                var crudArgs = { requestType: 'eventChanged', cancel: false, data: editArgs.changedRecords, promise: promise, editParams: editParams };
                _this.refreshData(crudArgs);
            }
        });
    };
    Crud.prototype.getParentEvent = function (event, isParent) {
        if (isParent === void 0) { isParent = false; }
        var parentEvent = this.parent.eventBase.getParentEvent(event, isParent) || event;
        if (parentEvent[this.parent.eventFields.startTimezone] || parentEvent[this.parent.eventFields.endTimezone]) {
            this.parent.eventBase.timezoneConvert(parentEvent);
        }
        return parentEvent;
    };
    Crud.prototype.excludeDateCheck = function (eventStartTime, exceptionDateList) {
        var exDate = getRecurrenceStringFromDate(eventStartTime);
        if (!isNullOrUndefined(exceptionDateList)) {
            if (exceptionDateList.indexOf(exDate) === -1) {
                exceptionDateList = !(isNullOrUndefined(exceptionDateList)) ? exceptionDateList + ',' + exDate : exDate;
            }
        }
        else {
            exceptionDateList = exDate;
        }
        return exceptionDateList;
    };
    Crud.prototype.processRecurrenceRule = function (parentEvent, followEvent) {
        var fields = this.parent.eventFields;
        var recurrenceRule = parentEvent[fields.recurrenceRule];
        var endDate;
        if (followEvent instanceof Date) {
            endDate = new Date(+followEvent);
        }
        else {
            endDate = new Date(+followEvent[fields.startTime]);
            var newRecurrenceRule = followEvent[fields.recurrenceRule];
            var startDate = parentEvent[fields.startTime];
            var ruleException = (this.parent.currentAction === 'DeleteFollowingEvents') ? followEvent[fields.recurrenceException] : null;
            var dateCollection = generate(startDate, newRecurrenceRule, ruleException, this.parent.activeViewOptions.firstDayOfWeek);
            var untilDate = new Date(dateCollection.slice(-1)[0]);
            untilDate.setHours(endDate.getHours(), endDate.getMinutes(), endDate.getSeconds());
            endDate.setHours(startDate.getHours(), startDate.getMinutes(), startDate.getSeconds());
            followEvent[fields.recurrenceRule] = this.getUpdatedRecurrenceRule(newRecurrenceRule, new Date(+untilDate), false);
        }
        parentEvent[fields.recurrenceRule] = this.getUpdatedRecurrenceRule(recurrenceRule, util.addDays(new Date(endDate.getTime()), -1), true);
    };
    Crud.prototype.getUpdatedRecurrenceRule = function (recurrenceRule, untilDate, isParent) {
        var splitRule = recurrenceRule.split(';');
        var updatedRule = '';
        for (var _i = 0, splitRule_1 = splitRule; _i < splitRule_1.length; _i++) {
            var rule = splitRule_1[_i];
            if (rule !== '') {
                var ruleKey = rule.split('=')[0];
                var ruleValue = rule.split('=')[1];
                if (ruleKey === 'COUNT' || ruleKey === 'UNTIL') {
                    ruleValue = getRecurrenceStringFromDate(untilDate);
                    rule = rule.replace(rule, 'UNTIL=' + ruleValue);
                }
                updatedRule += rule + ';';
            }
        }
        if (isParent && updatedRule.indexOf('UNTIL') === -1) {
            updatedRule += 'UNTIL=' + getRecurrenceStringFromDate(untilDate);
        }
        return updatedRule;
    };
    Crud.prototype.isBlockEvent = function (eventData) {
        var eventCollection = (eventData instanceof Array) ? eventData : [eventData];
        var value = false;
        for (var _i = 0, eventCollection_1 = eventCollection; _i < eventCollection_1.length; _i++) {
            var event_8 = eventCollection_1[_i];
            value = event_8[this.parent.eventFields.isBlock] || false;
        }
        return value;
    };
    /**
     * To destroy the crud module.
     *
     * @returns {void}
     * @private
     */
    Crud.prototype.destroy = function () {
        this.crudObj = null;
        this.parent = null;
    };
    return Crud;
}());
export { Crud };
